import script from "./UiDoubleDatepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDoubleDatepicker.vue?vue&type=script&setup=true&lang=js"

import "./UiDoubleDatepicker.vue?vue&type=style&index=0&id=cff08648&lang=scss"

const __exports__ = script;

export default __exports__